var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Layout Layout--default"},[_c('layout-header'),_c('div',{staticClass:"Layout-content"},[_vm._t("default")],2),_c('layout-footer'),_c('toasters'),_c('redirect')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }